<template>
  <div>
    <SimpleHeader />
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="teamw">
        <div class="blockyck">
          <div>
            <span>{{ balanceUnit(moneyInfo.balance).balance_c }}</span>
            <span>{{ depositName }}余额({{ balanceUnit(moneyInfo.balance).company }})</span>
            <div class="flex">
              <span class="yck-btn" @click="toCzPage">充值</span>
              <span class="yck-btn" v-if="isEnableDepositTransfer&&isAgent" @click="chooseAgent">转赠</span>
            </div>
            <!-- :style="'background-color:' + theme.PrimaryButtonColor + ';border-color:' + theme.PrimaryButtonColor" -->
          </div>
          <div>
            <span>{{ balanceUnit(moneyInfo.checkingAmount).balance_c }}</span>
            <span>{{ `待审核(${balanceUnit(moneyInfo.checkingAmount).company})` }}</span>
            <span class="yck-btn" @click="toRecordPage">查看</span>
          </div>
        </div>
        <div class="searchBlock">
          <div class="search-number">
            <div class="search-input">
              <!--              <input-->
              <!--                class="input"-->
              <!--                v-model="keyword"-->
              <!--                type="text"-->
              <!--                @keyup.enter="search()"-->
              <!--                placeholder="搜索订单编号或充值单号"-->
              <!--              />-->

              <van-field class="input" v-model="keyword" :clearable="true" placeholder="搜索" />
            </div>
            <div class="search-button" @click="search()">搜索</div>
          </div>
          <div class="sift-box" style="display: none">
            <div class="sift-box--conent">
              <div class="sift-item pr-20px font-w flex--c arrow" @click="timePickerShow">
                <div>{{ time.timeTitle }}</div>
              </div>
              <div class="sift-item fcontentCenter" @click="timeChangeShow('startDate')">
                <div :class="{ hasValue: time.startDate != '' }">{{ time.startDate || '开始时间' }}</div>
              </div>
              <div class="sift-item fcontentCenter" @click="timeChangeShow('endDate')">
                <div :class="{ hasValue: time.endDate != '' }">{{ time.endDate || '结束时间' }}</div>
              </div>
            </div>
          </div>
          <div class="sift-box">
            <div class="sift-box--conent">
              <div class="sift-item pr-20px font-w flex--c arrow xiala" @click="timePickerShow">
                <div>{{ time.timeTitle }}</div>
              </div>
              <div class="sift-item flex--c font-w arrow xiala" @click="pickerShow()">
                <div class="sift-item-title">{{ typeList[typeIndex].title || '全部' }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="tbflexBox">
          <div class="tbflexBox-one bright">
            <span :class="{ 'tbflexBox-one_top': true, blackColor: typeIndex != 1 }">{{
              balanceUnit(inAmount).balance_c
            }}</span>
            <span class="tbflexBox-one_bottom">{{ `进账(${balanceUnit(inAmount).company})` }}</span>
          </div>
          <div class="tbflexBox-one">
            <span :class="{ 'tbflexBox-one_top': true, blackColor: typeIndex != 2 }">{{
              balanceUnit(outAmount).balance_c
            }}</span>
            <span class="tbflexBox-one_bottom">{{ `出账(${balanceUnit(outAmount).company})` }}</span>
          </div>
        </div>
        <van-list
          v-model:loading="loading"
          :finished="loadObj.finished"
          @load="onLoad"
          :immediate-check="false"
          :finished-text="list.length ? `共${loadObj.count}条数据，已全部加载完成` : ''"
          :loading-text="`已经加载${list.length}条数据，共${loadObj.count}条数据`"
        >
          <div class="attention">
            <WalletItem v-for="(item, i) in list" :key="i" :item="item" />
          </div>
        </van-list>
        <Empty
          :show="list.length == 0 && loadObj.finished"
          title=""
          subTitle="暂无数据"
          btnTxt=""
          img="https://x.jzbull.com/x_dsx_h5/icons/wu.png"
        />
        <div class="popBox" v-show="toast">
          <van-picker
            class="popBottom"
            title="请选择"
            :default-index="typeIndex"
            show-toolbar
            :columns-field-names="customFieldName"
            :columns="typeList"
            @confirm="onConfirmToast"
            @cancel="onCancelToast"
          />
        </div>
        <div class="popBox" v-show="time.timePicker">
          <van-picker
            class="popBottom"
            title="请选择"
            show-toolbar
            :default-index="time.timeIndex"
            :columns="timeTypeList"
            @confirm="onConfirm"
            @cancel="onCancel"
          />
        </div>
        <div class="popBox" v-show="time.timeWhen">
          <van-date-picker
            v-model="show_time"
            class="popBottom"
            title="选择时间"
            @confirm="onConfirmTime"
            @cancel="onCancelTime"
          />
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script>
import { reactive, onMounted, nextTick, ref, toRefs, watch, computed } from 'vue'
import useTime from '@/utils/time'
import { useRoute } from 'vue-router'
import { List, PullRefresh, Tab, Tabs } from 'vant'
import { Toast } from '@vant/compat'
import SimpleHeader from '@/components/SimpleHeader'
import timeTypeList from '@/utils/timeType'
import utils from '@/utils'
import WalletItem from './components/WalletItem.vue'
import { getPreFundInvestDetailList, getPreFundInvestBalance } from '@/api/yck'
import usePage from '@/hooks/usePage'
import Empty from '../withdrawal/components/empty.vue'
import { getLocal, balanceUnit } from '@/common/js/utils'
import { useUserStore } from '@/store/user'

export default {
  name: 'teamDetail',
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    SimpleHeader,
    WalletItem,
    Empty
  },
  setup() {
    const { query } = useRoute()
    const toast = ref(false)
    const { navigateTo } = usePage()
    const userStore = useUserStore()
    const theme = computed(() => userStore.getTheme)
    const isEnableDepositTransfer = computed(() => userStore.getSettingInfo?.isEnableDepositTransfer)
    const isAgent = computed(() => userStore.getUserInfo?.agentInfo?.agentLevel > -1)
    const depositName = computed(() => userStore.getDepositName)
    // console.log(userStore.getUserInfo);
    
    const outAmount = ref(0)
    const inAmount = ref(0)
    const moneyInfo = ref({
      checkingAmount: '--',
      balance: '--'
    })
    const customFieldName = {
      text: 'title'
    }
    const keyword = ref('')
    let ajaxing = ref(false)
    let loading = ref(false)
    let refreshing = ref(false)

    const typeIndex = ref(0)
    const typeList = ref([
      { title: '全部', value: 0 },
      { title: '进账', value: 1 },
      { title: '出账', value: -1 }
    ])
    function pickerShow() {
      toast.value = true
    }

    async function onConfirmToast({ selectedOptions }) {
      typeIndex.value = typeList.value.findIndex(ele => ele.value == selectedOptions[0].value)
      await search()
      toast.value = false
    }

    function onCancelToast() {
      toast.value = false
    }

    const search = () => {
      resetList()
      getList()
    }

    function onLoad() {
      getList()
    }

    async function getInfo() {
      moneyInfo.value = await getPreFundInvestBalance()
    }

    const { time, show_time, onConfirmTime, onCancelTime, timeChangeShow, timePickerShow, onConfirm, onCancel } =
      useTime()

    //标签切换
    const active = ref(0)
    if (query && query.hasOwnProperty('tab')) {
      active.value = ~~query.tab
    }

    const state = reactive({
      timeTypeList,
      limitDate: utils.computedTime('today').endDate
    })

    // 刷新和加载更多开始
    const loadObj = reactive({
      // loading: false,
      // refreshing: false,
      finished: false,
      page: 1,
      pageSize: 20,
      count: 0
    })
    const list = ref([])
    async function getList() {
      if (ajaxing.value) return
      let params = {
        page: loadObj.page,
        pageSize: loadObj.pageSize,
        ioType: typeList.value[typeIndex.value].value || 0,
        startDate: time.startDate,
        endDate: time.endDate,
        bizSn: keyword.value
      }

      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      ajaxing.value = true
      let res = await getPreFundInvestDetailList(params)
      Toast.clear()
      ajaxing.value = false
      loading.value = false
      if (loadObj.page === 1) {
        loadObj.count = res.total
        // list.value = []
        inAmount.value = res.inAmount
        outAmount.value = res.outAmount
      }

      list.value = [...list.value, ...res.list]
      if (list.value.length >= res.total) {
        loadObj.finished = true //加载所有数据完成
      } else {
        loadObj.page = loadObj.page + 1 // 每次加载后page+1
      }
    }

    watch(
      () => [time.startDate, time.endDate, active.value],
      () => {
        search()
      }
    )

    function toCzPage() {
      navigateTo('/yckcz')
    }
    function toRecordPage() {
      navigateTo('/yckrecord')
    }
    function chooseAgent() {
      navigateTo('/chooseAgent')
    }

    //重置
    function resetSearchOptions() {
      active.value = 0
      typeIndex.value = 0
      time.startDate = ''
      time.endDate = ''
      time.timeTitle = '全部时间'
      time.timeIndex = 0
    }

    function resetList() {
      list.value = []
      loading.value = false
      loadObj.finished = false
      refreshing.value = false
      loadObj.page = 1
      loadObj.count = 0
      ajaxing.value = false
    }
    const onRefresh = () => {
      search()
      getInfo()
    }

    // nextTick(() => {
    //   window.addEventListener('scroll', () => {})
    // })

    onMounted(async () => {
      if (query && query.hasOwnProperty('tab')) {
        active.value = query.tab
      }
      resetSearchOptions()
      getInfo()
      search()
    })

    return {
      ...toRefs(state),
      ajaxing,
      loading,
      refreshing,
      loadObj,
      inAmount,
      outAmount,
      customFieldName,
      resetSearchOptions,
      getInfo,
      getList,
      resetList,
      search,
      onLoad,
      onRefresh,
      list,
      pickerShow,
      onConfirm,
      onCancel,
      onConfirmToast,
      onCancelToast,
      time,
      show_time,
      timeChangeShow,
      timePickerShow,
      onCancelTime,
      onConfirmTime,
      typeList,
      typeIndex,
      toast,
      timeTypeList,
      active,
      moneyInfo,
      toCzPage,
      toRecordPage,
      theme,
      keyword,
      balanceUnit,
      chooseAgent,
      isEnableDepositTransfer,
      isAgent
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../common/style/searchpicker';

:deep(.van-cell) {
  padding: 0;
}

.tbflexBox {
  margin-top: 0;
  .tbflexBox(17px, #ff6060, bold, 28px, 20px, #666666, normal, 20px, 14px);
  padding-top: 0;
  background: #fff;
  .blackColor {
    color: #222 !important;
  }
}
.container {
  background: #f8f8f8;
  width: 100%;
  height: 100%;
  position: relative;
}

.searchBlock {
  margin: 0;
  padding: 8px 15px 10px;
  background: #fff;
  //   height: 90px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.sift-box {
  width: 100%;
  margin-bottom: 8px;
}

.search-number {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  .picker {
    width: 112px;
    padding: 0 20px 0 15px;
    font-weight: 510;
    height: 36px;
    position: relative;
    background: #ffffff;
    border: 0.5px solid #dbdbdb;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #222222;
    &:after {
      position: absolute;
      content: '';
      top: 50%;
      transform: translateY(-50%);
      right: 12px;
      border-top: 6px solid #1a1a1a;
      border-right: 5px solid transparent;
      border-left: 5px solid transparent;
    }
  }
  .search-input {
    flex: 1;
    height: 36px;
    background: #ffffff;
    border: 0.5px solid rgba(219, 219, 219, 1);
    display: flex;
    align-items: center;
    position: relative;
    padding: 0 15px 0 33px;
    margin-right: 8px;
    &:before {
      position: absolute;
      content: '';
      top: 50%;
      left: 7px;
      transform: translateY(-50%);
      width: 24px;
      height: 24px;
      background: url('https://x.jzbull.com/x_dsx_h5/icons/search.png') no-repeat;
      background-size: 100%;
    }
    & > input {
      width: 100%;
      font-size: 14px;
      color: #999999;
    }
  }
  .search-button {
    width: 64px;
    height: 36px;
    background: #ff6060;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #ffffff;
  }
}
.yjdata {
  height: 82px;
  width: 100%;
  display: flex;
  background: #fff;
  > div {
    flex: 1;
    flex-direction: column;
  }
  .yjdata-num {
    font-size: 16px;
    color: #222;
    line-height: 22px;
    font-weight: bold;
    margin-bottom: 4px;
  }
  .yjdata-title {
    color: #666666;
    line-height: 20px;
    font-size: 14px;
  }
}
.yjman {
  width: 345px;
  margin: 0 auto;
  height: 88px;
  padding: 15px 0;
  border-bottom: 0.5px solid #dbdbdb;
  display: flex;
  &-pic {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    margin-right: 8px;
  }
  &-cont {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .yjman-tel {
    color: #999999;
    line-height: 20px;
    font-size: 14px;
  }
  .yjman-nameblock {
    display: flex;
    align-items: center;
    .yjman-name {
      color: #222;
      line-height: 22px;
      font-size: 16px;
      font-weight: bold;
    }
    .jyman-level {
      height: 21px;
      min-width: 58px;
      border: 0.5px solid #ff6060;
      // border-radius: 5px;
      color: #ff6060;
      font-size: 12px;
      margin-left: 10px;
    }
  }
}
.yj-single {
  background: #fff;
  overflow: hidden;
  margin-bottom: 10px;
}
.teamw,
.attention {
  background: #f8f8f8;
}
.attention {
  margin-bottom: -1px;
}
</style>

<style lang="less" scoped>
.findTabs {
  background: #fff;
  .van-tab__text {
    font-size: 14px;
  }
  .van-tab {
    padding: 0 10px;
  }
  .van-tab--active .van-tab__text {
    font-size: 16px;
  }
  .van-tabs__line {
    border: 2px solid #ff6060 !important;
    bottom: 20px !important;
  }
  .van-tabs__content {
    margin-top: -4px;
  }
}
.van-list__finished-text {
  background: #f8f8f8;
}
.xiala {
  width: 168px !important;
}
.bright {
  border-right: 0.5px solid #eee;
}
.sift-box--conent {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.tbflexBox-one_top {
  color: #ff6060 !important;
}
.blockyck {
  height: 144px;
  margin-bottom: 8px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px 12px;
  > div {
    width: 168px;
    height: 120px;
    &:nth-child(1) {
      border-right: 0.5px solid #dbdbdb;
    }
    // background: linear-gradient(134deg, #ffffff 5%, #ffffff 35%, #ffffff 97%);
    // border-radius: 12px;
    // box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding-top: 15px;
    span:nth-child(1) {
      color: #222;
      line-height: 28px;
      font-weight: bold;
      font-size: 24px;
    }
    span:nth-child(2) {
      color: #666666;
      line-height: 20px;
      font-size: 14px;
    }
    .yck-btn {
      width: 64px;
      height: 30px;
      background: #ffffff;
      border: 1px solid #222;
      color: #222 !important;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 14px !important;
      margin-top: 15px;
      font-weight: inherit !important;
      & + .yck-btn {
        margin-left: 10px;
      }
    }
  }
}
</style>
